(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('FleetDailyTripDialogController', FleetDailyTripDialogController);

    FleetDailyTripDialogController.$inject = ['$scope', '$uibModalInstance', 'DataUtils', 'entity', 'FleetDailyTrip', 'AlertService'];

    function FleetDailyTripDialogController ($scope, $uibModalInstance, DataUtils, entity, FleetDailyTrip, AlertService) {
        var vm = this;

        vm.fleetDailyTrip = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.setFile = setFile;
        vm.errorMessage = null;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            if (!vm.fleetDailyTrip.file) {
                vm.errorMessage = "Veuillez sélectionner un fichier Excel.";
                return;
            }
            vm.isSaving = true;
            vm.errorMessage = null;
            FleetDailyTrip.importFile({}, vm.fleetDailyTrip, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            if (result && result.success === false) {
                vm.errorMessage = result.message || "Erreur lors de l'import.";
                return;
            }
            var imported = result && typeof result.imported === 'number' ? result.imported : 0;
            AlertService.success(imported + " trajet(s) importé(s)");
            $scope.$emit('tmgApp:fleetDailyTripUpdate', result);
            $uibModalInstance.close(result);
        }

        function onSaveError (response) {
            vm.isSaving = false;
            var msg = "Erreur lors de l'import.";
            if (response && response.data && response.data.message) {
                msg = response.data.message;
            } else if (response && response.headers) {
                var headerMsg = response.headers('X-tmgApp-error');
                if (headerMsg) {
                    msg = headerMsg;
                }
            }
            vm.errorMessage = msg;
            AlertService.error(msg);
        }

        function setFile ($file) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        vm.fleetDailyTrip.fileName = $file.name;
                        vm.fleetDailyTrip.file = base64Data;
                        vm.fleetDailyTrip.fileContentType = $file.type;
                        vm.errorMessage = null;
                    });
                });
            }
        }
    }
})();
